import { FiClock } from "react-icons/fi";
import { useEffect, useState } from 'react';
import { socket, axiosInstance } from '../../config';
import './chatpopout.css';

const ChatPopout = () => {
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState('');
  const [rateLimitError, setRateLimitError] = useState('');

  useEffect(() => {
    console.log('Chat popout mounted');
    
    // Load previous messages
    const fetchMessages = async () => {
      try {
        const res = await axiosInstance.get('/chats/spirit');
        // Messages come from backend in descending order (newest first)
        // We need to reverse them to show oldest first, newest last
        const messagesArray = Array.isArray(res.data) ? res.data.reverse() : [];
        setMessages(messagesArray);
      } catch (err) {
        console.error('Failed to fetch messages:', err);
      }
    };

    fetchMessages();

    // Listen for new messages
    socket.on('chat message spirit', (newMessage) => {
      console.log('📱 ChatPopout Debug: Received socket message:', newMessage);
      if (newMessage && typeof newMessage === 'object') {
        setMessages(prev => {
          // Check if this message already exists to prevent duplicates
          const messageExists = prev.some(msg => 
            msg.user === newMessage.user && 
            msg.text === newMessage.text && 
            msg.timestamp === newMessage.timestamp
          );
          
          if (messageExists) {
            console.log('📱 ChatPopout Debug: Duplicate message detected, skipping');
            return prev; // Don't add duplicate
          }
          
          // Add new message at the end (newest last)
          const newMessages = [...prev, newMessage];
          console.log('📱 ChatPopout Debug: Added new message, total count:', newMessages.length);
          return newMessages;
        });
      }
    });

    return () => {
      socket.off('chat message spirit');
    };
  }, []);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!messageInput.trim()) return;

    // Check for links in the message
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[a-z]{2,}\/[^\s]*)/gi;
    if (urlRegex.test(messageInput)) {
      setRateLimitError("Links are not allowed in chat!");
      setTimeout(() => setRateLimitError(''), 3000);
      return;
    }

    try {
      const messageData = {
        user: 'Anonymous', // You might want to get the actual user from context
        text: messageInput,
        timestamp: new Date().toISOString(),
        streamer: 'spirit'
      };

      const res = await axiosInstance.post('/chats/spirit', messageData);
      console.log('📱 ChatPopout Debug: Message sent successfully:', res.data);
      setMessageInput('');
    } catch (err) {
      console.error('Failed to send message:', err);
      
      // Handle rate limit error
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError(errorData.error || "You're sending messages too fast.");
        // Clear the error after 3 seconds
        setTimeout(() => setRateLimitError(''), 3000);
      }
    }
  };

  return (
    <div className="chat-popout">
      <div className="chat-header">
        {/* <h3>CHAT</h3> */}
      </div>
      
      <div className="chat-messages">
        {messages.map((msg, index) => (
          <div key={index} className="chat-message">
            <strong>{msg.user}:</strong> {msg.text}
          </div>
        ))}
      </div>
      
      {/* Rate Limit Error Notification */}
      {rateLimitError && (
        <div className="rate-limit-error">
          <div className="rate-limit-icon"><FiClock /></div>
          <span className="rate-limit-text">{rateLimitError}</span>
        </div>
      )}
      
      <form onSubmit={handleSendMessage} className="chat-input-wrapper">
        <input
          type="text"
          value={messageInput}
          onChange={(e) => setMessageInput(e.target.value)}
          placeholder="Type a message..."
          className="chat-input"
        />
        <button type="submit" className="chat-send-btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fill="currentColor"/>
          </svg>
        </button>
      </form>
    </div>
  );
};

export default ChatPopout; 